var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"singleChoiceItem",on:{"click":_vm.chioseChange}},[_c('div',{staticClass:"itemIcon",class:{ ischecked: _vm.isChecked }},[_c('checked-box-icon',{staticClass:"checkedBoxIcon"})],1),_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }